import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CONSTANTS } from "app/constants";
import { PlayerDto, PlayerTrainingResultDto, SquadNumberDto, UpdateSquadNumbersRequestDto } from "app/models";
import { ConfigurationService, NotificationService, PlayerService, TeamService } from "app/services";
import { ChangeSquadNumberModal, DeleteConfirmationModal } from "..";

@Component({
    selector: 'team-players-list',
    templateUrl: './team-players.component.html',
    styleUrls: ['./team-players.component.scss'],
})
export class TeamPlayersList implements OnInit {
    
    players: PlayerDto[];
    fieldPlayers: PlayerDto[];
    gkPlayers: PlayerDto[];
    sortedPlayersList: PlayerDto[];
    sortedGkList: PlayerDto[];
    skillsGrowth: PlayerTrainingResultDto[];
    latestGraduates: number[];
    filteredSquad: PlayerDto[];
    filteredGKs: PlayerDto[];
    numbers: SquadNumberDto[];
    numbersDictionary = [];
    nationalBans: number[];
    euroCupBans: number[];

    columnTypes: number = CONSTANTS.rosterColumnTypes.general;

    currTeamId: number;

    baseFintUrl: string;

    showFilters: boolean = false;

    filters = {
        gk: true,
        sw: true,
        df: true,
        dm: true,
        mf: true,
        am: true,
        fw: true,
        l: true,
        c: true,
        r: true,
        loanIn: true,
        loanOut: true,
    }

    sortDirection: number = CONSTANTS.sortDirection.asc;
    sortField: number = CONSTANTS.rosterSortFields.position;

    const;

    @Input()
    set squad(val: PlayerDto[]){
        this.players = val;
        if (val) {
            this.fieldPlayers = [];
            this.gkPlayers = [];
            val.forEach(item => {
                if (item.isGK) {
                    this.gkPlayers.push(item);
                } else {
                    this.fieldPlayers.push(item);
                }
            })

            this.sortPlayers();
        }
    }

    get squad(): PlayerDto[] {
        return this.players;
    }

    @Input()
    set skills(val: PlayerTrainingResultDto[]){
        
        this.skillsGrowth = [];

        if (val) {

            val.forEach(item => {
                this.skillsGrowth[item.playerId] = item;
            });
        }
    }

    get skills(): PlayerTrainingResultDto[] {
        return this.skillsGrowth;
    }

    @Input()
    set graduates(val: number[]){
        
        this.latestGraduates = [];

        if (val) {

            val.forEach(item => {
                this.latestGraduates[item] = item;
            });
        }
    }

    get graduates(): number[] {
        return this.latestGraduates;
    }

    @Input()
    set teamId(val: number){
        
        this.currTeamId = val;
    }

    get teamId(): number {
        return this.currTeamId;
    }

    @Input()
    set squadNumbers(val: SquadNumberDto[]){
        
        this.numbers = val;
        this.numbersDictionary = [];

        if (val) {
            this.buildNumberDictionary();
        }
    }

    get squadNumbers(): SquadNumberDto[] {
        return this.numbers;
    }

    @Input()
    set natBans(val: number[]){
        this.nationalBans = val;
    }

    get natBans(): number[] {
        return this.nationalBans;
    }

    @Input()
    set euroBans(val: number[]){
        this.euroCupBans = val;
    }

    get euroBans(): number[] {
        return this.euroCupBans;
    }
    
    constructor(private playerService: PlayerService, 
        configurationService: ConfigurationService,
        private modalService: NgbModal,
        private teamService: TeamService,
        private notificationService: NotificationService){
        this.baseFintUrl = configurationService.getFintFMUrl();

        this.const = CONSTANTS;
    }


    ngOnInit(): void {
    }

    getPlayerName(player: PlayerDto) {
        if (!player.name)
            return player.surname;
        
        if (this.columnTypes === CONSTANTS.rosterColumnTypes.skills) {
            return (player.name[0] + ". " + player.surname).trim();
        }

        let result = player.name + " " + player.surname;

        return result.trim();
    }

    getPlayerPositionLabel(player: PlayerDto) {
        return this.playerService.formatPlayerPosition(player);
    }

    hasSkillGrowUp(playerId: number): boolean {
        if (!this.skillsGrowth || this.skillsGrowth.length === 0) {
            return false;
        }

        let item = this.skillsGrowth[playerId];

        if (!item || !item.skillReports) {
            return false;
        }

        let isGrowUp = item.skillReports.find(i => i.isUp);

        return isGrowUp != null;
    }

    hasSkillTearDown(playerId: number): boolean {
        if (!this.skillsGrowth || this.skillsGrowth.length === 0) {
            return false;
        }

        let item = this.skillsGrowth[playerId];

        if (!item || !item.skillReports) {
            return false;
        }

        let isDown = item.skillReports.find(i => !i.isUp);

        return isDown != null;
    }

    isLastGraduates(playerId: number): boolean {
        if (!this.graduates) {
            return false;
        }
        
        let val = this.graduates[playerId];

        if (val) return true;

        return false;
    }

    toggleGk() {
        if (this.filterPositionsSelectedCount() === 1 && this.filters.gk) {
            return;
        }

        this.filters.gk = !this.filters.gk;
        this.filterPlayers();
    }

    toggleSW() {
        if (this.filterPositionsSelectedCount() === 1 && this.filters.sw) {
            return;
        }

        this.filters.sw = !this.filters.sw;
        this.filterPlayers();
    }

    toggleDF() {
        if (this.filterPositionsSelectedCount() === 1 && this.filters.df) {
            return;
        }

        this.filters.df = !this.filters.df;
        this.filterPlayers();
    }

    toggleDM() {
        if (this.filterPositionsSelectedCount() === 1 && this.filters.dm) {
            return;
        }

        this.filters.dm = !this.filters.dm;
        this.filterPlayers();
    }

    toggleMF() {
        if (this.filterPositionsSelectedCount() === 1 && this.filters.mf) {
            return;
        }

        this.filters.mf = !this.filters.mf;
        this.filterPlayers();
    }

    toggleAM() {
        if (this.filterPositionsSelectedCount() === 1 && this.filters.am) {
            return;
        }

        this.filters.am = !this.filters.am;
        this.filterPlayers();
    }

    toggleFW() {
        if (this.filterPositionsSelectedCount() === 1 && this.filters.fw) {
            return;
        }

        this.filters.fw = !this.filters.fw;
        this.filterPlayers();
    }

    toggleL() {
        if (this.filterSidesSelectedCount() === 1 && this.filters.l) {
            return;
        }

        this.filters.l = !this.filters.l;
        this.filterPlayers();
    }

    toggleC() {
        if (this.filterSidesSelectedCount() === 1 && this.filters.c) {
            return;
        }

        this.filters.c = !this.filters.c;
        this.filterPlayers();
    }

    toggleR() {
        if (this.filterSidesSelectedCount() === 1 && this.filters.r) {
            return;
        }

        this.filters.r = !this.filters.r;
        this.filterPlayers();
    }

    toggleLoanOut() {
        this.filters.loanOut = !this.filters.loanOut;
        this.filterPlayers();
    }

    toggleLoanIn() {
        this.filters.loanIn = !this.filters.loanIn;
        this.filterPlayers();
    }

    closeFilter(ev) {
        ev.stopPropagation();

        this.showFilters = false;
    }

    showFilter(ev) {
        ev.stopPropagation();

        this.showFilters = true;
    }

    changeSortMode(sortField: number) {
        if (this.sortField === sortField) {
            this.sortDirection = this.sortDirection === CONSTANTS.sortDirection.asc 
            ? CONSTANTS.sortDirection.desc: CONSTANTS.sortDirection.asc;
        } else {
            this.sortField = sortField;
            this.sortDirection = 
                (sortField === CONSTANTS.rosterSortFields.name || sortField === CONSTANTS.rosterSortFields.age || sortField === CONSTANTS.rosterSortFields.position)  
                ? CONSTANTS.sortDirection.asc : CONSTANTS.sortDirection.desc;
        }

        this.sortPlayers();
    }

    onchangeNumber(player: PlayerDto) {
        if (player.teamId != this.currTeamId) {
            return;
        }

        const modalRef = this.modalService.open(ChangeSquadNumberModal);

        modalRef.componentInstance.numbers = this.numbers;
        modalRef.componentInstance.player = player;
        modalRef.componentInstance.playerPosition = this.playerService.formatPlayerPosition(player);

        modalRef.result.then((result) => {
            if (result) {


                    let updateRequest = new UpdateSquadNumbersRequestDto();
                        updateRequest.teamId = this.currTeamId;
                        updateRequest.numbers = [];

                    let selectedNumber = this.numbers.find(f => f.number == result);
                    
                    if (selectedNumber && selectedNumber.playerId == player.id) {
                        return;
                    }

                    if (selectedNumber) {
                        const modalRef2 = this.modalService.open(DeleteConfirmationModal);
                        modalRef2.componentInstance.title = "Номер уже занят другим игроком.";
                        modalRef2.result.then((result) => {
                            if (result) {
                                //first item to delete
                                let number1 = new SquadNumberDto();
                                number1.playerId = selectedNumber.playerId;
                                number1.number = null;
    
                                updateRequest.numbers.push(number1);

                                //second item to update
                                let number2 = new SquadNumberDto();
                                number2.playerId = player.id;
                                number2.number = selectedNumber.number;
    
                                updateRequest.numbers.push(number2);


                                selectedNumber.playerId = player.id;

                                this.teamService.updateSquadNumbers(updateRequest)
                                    .subscribe(result => {
                                        this.buildNumberDictionary();
                                        this.notificationService.showSuccess('Игровой номер обновлен.')
                                    }, error => {
                                        this.notificationService.showError('Ошибка обновления игровых номеров.')
                                });
                            }
                        });
                    } else {

                        let currentNumber = this.numbers.find(f => f.playerId == player.id);
                        if (currentNumber) {
                            currentNumber.number = result;
                            updateRequest.numbers.push(currentNumber);
                        } else {

                            let newNumber = new SquadNumberDto();
                            newNumber.playerId = player.id;
                            newNumber.number = result;
                            newNumber.teamId = this.currTeamId;

                            updateRequest.numbers.push(newNumber);
                            this.numbers.push(newNumber);
                        }

                        
                        this.teamService.updateSquadNumbers(updateRequest)
                            .subscribe(result => {
                                this.buildNumberDictionary();
                                this.notificationService.showSuccess('Игровой номер обновлен.')
                            }, error => {
                                this.notificationService.showError('Ошибка обновления игровых номеров.')
                        });

                }
            }
        }, (reason) => { });
    }

    formatCost(player: PlayerDto): string {
        return this.playerService.formatPlayerCost(player.cost);
    }

    onChangeColumnType(type: number) {
        this.columnTypes = type;
        this.sortField = CONSTANTS.rosterSortFields.position;
        this.sortDirection = CONSTANTS.sortDirection.asc;

        this.sortPlayers();
    }

    isPlayerNationalBanned(playerId: number) {
        return this.natBans && this.natBans[playerId];
    }

    isPlayerEuroBanned(playerId: number) {
        return this.euroBans && this.euroBans[playerId];
    }

    private filterPlayers() {
        let squad = [];
        let gks = [];

        if (this.sortedPlayersList) {
            this.sortedPlayersList.forEach(item => {
                if ((this.filters.loanIn || (!this.filters.loanIn && (!item.baseTeamId || item.baseTeamId == this.currTeamId)))
                    && (this.filters.loanOut || (!this.filters.loanOut && (!item.baseTeamId || item.baseTeamId != this.currTeamId)))
                    && (this.isFilterEmptyOrFull() || this.isPlayerMatchFilter(item))) {
                        squad.push(item);
                }
            });
        }

        if (this.sortedGkList) {
            this.sortedGkList.forEach(item => {
                if ((this.filters.loanIn || (!this.filters.loanIn && (!item.baseTeamId || item.baseTeamId == this.currTeamId)))
                    && (this.filters.loanOut || (!this.filters.loanOut && (!item.baseTeamId || item.baseTeamId != this.currTeamId)))
                    && (this.isFilterEmptyOrFull() || this.isPlayerMatchFilter(item))) {
                        gks.push(item);
                }
            });
        }

        this.filteredSquad = squad;
        this.filteredGKs = gks;
    }

    private isPlayerMatchFilter(player: PlayerDto): boolean {
        if (player.isGK && this.filters.gk)
            return true;

        let isPosMath = false;

        if ((!this.filters.l && !this.filters.r && !this.filters.c) ||
            ((player.isLeft && this.filters.l) || (player.isRight && this.filters.r) || (player.isCenter && this.filters.c)))
            isPosMath = true;

        if (!isPosMath)
            return false;

        if (!this.filters.gk && !this.filters.sw && !this.filters.df && !this.filters.dm && !this.filters.mf && !this.filters.am && !this.filters.fw)
            return true;

        if ((player.isSW && this.filters.sw) || (player.isDF && this.filters.df) || (player.isDM && this.filters.dm)
            || (player.isMF && this.filters.mf) || (player.isAM && this.filters.am) || (player.isFW && this.filters.fw))
            return true;

        return false;
        
    }

    private isFilterEmptyOrFull(): boolean {
        return (!this.filters.gk && !this.filters.sw && !this.filters.df && !this.filters.dm
        && !this.filters.mf && !this.filters.am && !this.filters.fw && !this.filters.l && !this.filters.c && !this.filters.r) ||
            (this.filters.gk && this.filters.sw && this.filters.df && this.filters.dm
                && this.filters.mf && this.filters.am && this.filters.fw && this.filters.l && this.filters.c && this.filters.r);
    }

    private filterPositionsSelectedCount() {
        return (this.filters.gk ? 1 : 0) +
            (this.filters.sw ? 1 : 0) + 
            (this.filters.df ? 1 : 0) + 
            (this.filters.dm ? 1 : 0) + 
            (this.filters.mf ? 1 : 0) + 
            (this.filters.am ? 1 : 0) + 
            (this.filters.fw ? 1 : 0);
    }

    private filterSidesSelectedCount() {
        return (this.filters.l ? 1 : 0) +
            (this.filters.c ? 1 : 0) + 
            (this.filters.r ? 1 : 0) ;
    }

    private sortPlayers() {
        if (!this.players) {
         return;
        }

        switch (this.sortField) {
            case CONSTANTS.rosterSortFields.age:
                this.sortedPlayersList = this.playerService.sortPlayersByAge(this.columnTypes === CONSTANTS.rosterColumnTypes.skills ? this.fieldPlayers : this.players, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByAge(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.name:
                this.sortedPlayersList = this.playerService.sortPlayersByName(this.columnTypes === CONSTANTS.rosterColumnTypes.skills ? this.fieldPlayers : this.players, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByName(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.position:
                this.sortedPlayersList = this.playerService.sortRosterPlayersByPosition(this.columnTypes === CONSTANTS.rosterColumnTypes.skills ? this.fieldPlayers : this.players, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortRosterPlayersByPosition(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.phys:
                this.sortedPlayersList = this.playerService.sortPlayersByPhys(this.players, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.morale:
                this.sortedPlayersList = this.playerService.sortPlayersByMorale(this.players, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.power:
                this.sortedPlayersList = this.playerService.sortPlayersByPower(this.columnTypes === CONSTANTS.rosterColumnTypes.skills ? this.fieldPlayers : this.players, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByPower(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.cost:
                this.sortedPlayersList = this.playerService.sortPlayersByCost(this.players, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.wage:
                this.sortedPlayersList = this.playerService.sortPlayersByWage(this.players, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.contractLength:
                this.sortedPlayersList = this.playerService.sortPlayersByContractLength(this.players, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillStamina:
                this.sortedPlayersList = this.playerService.sortPlayersByStamina(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByStamina(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillForce:
                this.sortedPlayersList = this.playerService.sortPlayersByForce(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByForce(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillSpeed:
                this.sortedPlayersList = this.playerService.sortPlayersBySpeed(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersBySpeed(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillLead:
                this.sortedPlayersList = this.playerService.sortPlayersByLeadership(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByLeadership(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillDribbling:
                this.sortedPlayersList = this.playerService.sortPlayersByDribbling(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByDribbling(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillTechnique:
                this.sortedPlayersList = this.playerService.sortPlayersByTechnique(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByTechnique(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillPowerShot:
                this.sortedPlayersList = this.playerService.sortPlayersByPowerShot(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByPowerShot(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillAccuracyShot:
                this.sortedPlayersList = this.playerService.sortPlayersByAccuracyShot(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByAccuracyShot(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillFreeKick:
                this.sortedPlayersList = this.playerService.sortPlayersByFreeKick(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByFreeKick(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillCornerKick:
                this.sortedPlayersList = this.playerService.sortPlayersByCornerKick(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByCornerKick(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillVision:
                this.sortedPlayersList = this.playerService.sortPlayersByVision(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByVision(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillPositioning:
                this.sortedPlayersList = this.playerService.sortPlayersByPositioning(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByPositioning(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillHead:
                this.sortedPlayersList = this.playerService.sortPlayersByHead(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByHead(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillTackling:
                this.sortedPlayersList = this.playerService.sortPlayersByTackling(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByTackling(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillCross:
                this.sortedPlayersList = this.playerService.sortPlayersByCross(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByCross(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
            case CONSTANTS.rosterSortFields.skillPass:
                this.sortedPlayersList = this.playerService.sortPlayersByPass(this.fieldPlayers, this.currTeamId, this.sortDirection);
                this.sortedGkList = this.playerService.sortPlayersByPass(this.gkPlayers, this.currTeamId, this.sortDirection);
            break;
        }


        this.filterPlayers();
    }

    private buildNumberDictionary() {
        this.numbersDictionary = [];
        this.numbers.forEach(item => {
            this.numbersDictionary[item.playerId] = item.number;
        })
    }
}